import script from "./subjectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./subjectPage.vue?vue&type=script&setup=true&lang=js"

import "./subjectPage.vue?vue&type=style&index=0&id=3fd6517a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fd6517a"]])

export default __exports__